<template>
  <div></div>
</template>

<script>
import page from '@/mixins/page'
import {mapActions} from 'vuex'

export default {
  name: 'email-reset',

  props: {
    companyId: {
      type: String,
      required: true
    },

    userId: {
      type: String,
      required: true
    },

    token: {
      type: String,
      required: true
    }
  },

  mixins: [page],

  data() {
    return {
      title: 'Email Successfully Reset'
    }
  },

  methods: {
    ...mapActions(['resetCurrentUserEmail'])
  },

  mounted() {
    const id = this.userId
    const token = this.token

    this.resetCurrentUserEmail({id, token})
      .then(() => {
        this.$router.push({
          name: 'company-user',
          params: {
            companyId: this.companyId,
            userId: this.userId
          },
          query: {emailReset: true}
        })
      })
      .catch(() => {
        alert('Error resetting email')
      })
  }
}
</script>
